module.exports = __webpack_public_path__ + "stockLibrary/simulator/010-3dbd9762dbc3fcb562ff30b3f5d6310b.png";